import React from "react";
import {tabletBreakpoint} from "~styles/common";
import styled from "styled-components";
import {SocialMediaItem} from "~components/social-media/data";

type PropTypes = {
    data: SocialMediaItem[];
}

export function SocialMedia({ data }: PropTypes) {
    return (
        <Wrapper>
            <Container>
                {data.map((i) => (
                    <Link
                        key={i.name}
                        target='blank'
                        href={i.url}
                    >
                        <Icon
                            alt={i.name}
                            src={i.image}
                        />
                    </Link>
                ))}
            </Container>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    padding: 7rem 0 3rem 0;

    @media (min-width: ${tabletBreakpoint}) {
        padding: 7rem 0;
    }
`;

const Container = styled.div`
    margin: 0 auto;
    display: flex;
    padding: 1.3rem 2.8rem;
    background-color: #FAFAFA;
    max-width: 393px;
    border-radius: 50px;
`;

const Link = styled.a`
    display: block;
    margin-right: 3.5rem;

    &:last-child{
        margin-right: 0;
    }

    &:hover{

        img{
            filter: opacity(0.5);
        }
    }
`;

const Icon = styled.img`
    filter: opacity(1);
    transition: filter .3s;
`;

